export const scrollToHash = (hash, offset = -84) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset, duration: 1.2 });
    else el.scrollIntoView({ behavior: "smooth" });
};
